import template from './base/base';

function App() {
  return template(<div></div>)
}

export default App;
